<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"></i> Créer un nouveau droit</strong>
          </div>
          <b-form-group label="Espace" label-for="basicSelect">
            <b-form-select
              id="basicSelect"
              :plain="true"
              v-on:change="espaceChanged"
              :options="espacesOptions"
              v-model="selectedEspace">
            </b-form-select>
            <span class="field-error">{{ errors.selectedEspace }}</span>
          </b-form-group>
          <b-form-group label="Module" label-for="basicSelect">
            <b-form-select
              id="basicSelect"
              :plain="true"
              :options="modulesOptions"
              v-model="selectedModule">
            </b-form-select>
          </b-form-group>
          <b-form-group label="Parent" label-for="basicSelect">
            <b-form-select
              id="basicSelect"
              :plain="true"
              :options="parentsOptions"
              v-model="selectedParent">
            </b-form-select>
          </b-form-group>
          <b-form-group
            description="Libelle du droit"
            label="Libelle"
            label-for="Libelle"
          >
            <b-form-input id="Libelle" type="text" :class="{hasError: errors.label !== ''}"
                          v-model="label"></b-form-input>
            <span class="field-error">{{ errors.label }}</span>
          </b-form-group>
          <b-form-group
            description="Libelle technique du droit"
            label="Libelle technique"
            label-for="tec_label"
          >
            <b-form-input id="tec_label" type="text" :class="{hasError: errors.labelTec !== ''}"
                          v-model="labelTec"></b-form-input>
            <span class="field-error">{{ errors.labelTec }}</span>
          </b-form-group>
          <b-form-group label="Root" label-for="root">
            <b-form-radio v-model="isRoot" name="root" value="1">OUI</b-form-radio>
            <b-form-radio v-model="isRoot" name="root" value="0">NON</b-form-radio>
          </b-form-group>
          <div slot="footer">
            <b-button type="button" @click="returnBack" size="md" variant="secondary">
              <i class="fa fa-arrow-left"></i> Liste des droits
            </b-button>
            <b-button type="button" @click="add" size="md" class="pull-right" variant="primary">
              <i class="fa fa-save"></i> Enregistrer
            </b-button>
          </div>
        </b-card>
      </b-col>
      <b-col md='6'>
        <b-card style="height: 560px; overflow-y: hidden;">
          <h4>Liste des profils pour rattachement au droit</h4>
          <b-form-checkbox
            class="mb-2 ml-1"
            v-model="allSelected"
            :indeterminate="indeterminate"
            aria-describedby="items"
            aria-controls="items"
            @change="toggleAll"
          >Tous sélectionner
          </b-form-checkbox>
          <VuePerfectScrollbar class="scroll-area-oap-oag" :settings="psSettings" @ps-scroll-y="scrollHandle">
            <b-form-group
              v-slot="{ ariaDescribedby }" 
            >
              <b-form-checkbox v-for="profil in allProfil"
                class="ml-1"
                v-model="selectedProfils"
                :value="profil.id"
                :aria-describedby="ariaDescribedby"
                name="profils"
                :key="profil.id"
                stacked
              >{{ profil.libelle }}</b-form-checkbox>
            </b-form-group>
          </VuePerfectScrollbar>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {getBaseUrl, getProvider, getIdToken, getAccessToken} from '../../../utils/auth'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'

  export default {
    components: {
      VuePerfectScrollbar
    },
    data() {
      return {
        espacesOptions: [],
        modulesOptions: [],
        parentsOptions: [],
        selectedEspace: null,
        selectedModule: null,
        selectedParent: null,
        allProfil: [],
        selectedProfils: [],
        indeterminate: false,
        allSelected: false,
        isRoot: "0",
        label: '',
        labelTec: '',
        errors: {
          selectedEspace: '',
          label: '',
          labelTec: ''
        }
      };
    },
    watch: {
      selectedProfils(newVal, oldVal) {
        // Handle changes in individual checkboxes
        if (newVal.length === 0) {
          this.indeterminate = false
          this.allSelected = false
        } else if (newVal.length === this.allProfil.length) {
          this.indeterminate = false
          this.allSelected = true
        } else {
          this.indeterminate = true
          this.allSelected = false
        }
      },
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.getProfiles();
      this.getEspaces();
    },
    computed: {
      psSettings: () => {
        // ToDo: find better rtl fix
        return {
          maxScrollbarLength: 200,
          minScrollbarLength: 40,
          suppressScrollX: getComputedStyle(document.querySelector('html')).direction !== 'rtl',
          wheelPropagation: false,
          interceptRailY: styles => ({ ...styles, height: 0 })
        }
      }
    },
    methods: {
      scrollHandle (evt) {
        // console.log(evt)
      },
      getProfiles() {
        this.$axios
          .get("/administration/profiles")
          .then(response => {
            this.allProfil = response.data.profils;
            // for(let profile of response.data.profiles){
            //   this.structuresOptions.push({value: structures.id, text: structures.libelle});
            // }
          })
          .catch((error) => {
            self.handleError(error);
          });
      },
      toggleAll(checked) {
        this.selectedProfils = checked ? this.allProfil.map(item => {
          return item.id
        }) : []
      },
      getEspaces() {
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/administration/espaces')
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            const espaces = response.data.espaces;
            for (let i = 0; i < espaces.length; i++) {
              this.espacesOptions.push({
                text: espaces[i].nom,
                value: espaces[i].id
              });
            }
          });
      },
      getModules() {
        this.modulesOptions = [];
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/administration/modules_espace/'+this.selectedEspace)
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            const modules = response.data.modules;
            for (let i = 0; i < modules.length; i++) {
              this.modulesOptions.push({
                text: modules[i].nom,
                value: modules[i].id
              });
            }
          });
      },
      getParents() {
        this.parentsOptions = [];
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/administration/droits_espace/'+ this.selectedEspace)
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            const parents = response.data.droits;
            for (let i = 0; i < parents.length; i++) {
              this.parentsOptions.push({
                text: parents[i].libelle,
                value: parents[i].id
              });
            }
          });
      },
      espaceChanged() {
        this.getModules();
        this.getParents();
      },
      add() {
        if (this.validateData()) {
          this.$store.commit('IS_LOADING', true)
          let self = this;
          let dataPost = {};
          dataPost.espace_id = this.selectedEspace;
          dataPost.module_id = this.selectedModule;
          dataPost.parent_id = this.selectedParent;
          dataPost.label = this.label;
          dataPost.labelTec = this.labelTec;
          dataPost.is_root = this.isRoot;
          dataPost.profilIds = this.selectedProfils;
          
          this.$axios
            .post("/administration/droits", dataPost)
            .then(() => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({
                position: 'top',
                type: 'success',
                title: 'Création avec succès',
                text: 'Le droit ' + dataPost.label + ' a bien été créé',
                showConfirmButton: false,
                timer: 5000
              });
              this.returnBack()
            })
            .catch(() => {
              self.$store.commit('IS_LOADING', false);
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Un problème est survenu, merci de contacter l\'administration',
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      returnBack() {
        this.$router.push({path: '/administration/rules'})
      },
      validateData() {
        this.clearErrors();
        let valid = true;
        if (this.selectedEspace === null) {
          this.errors.selectedEspace = "L'espace est obligatoire";
          valid = false;
        }
        if (this.label === "") {
          this.errors.label = "Le libellé est obligatoire";
          valid = false;
        }
        if (this.labelTec === "") {
          this.errors.labelTec = "Le libellé technique est obligatoire";
          valid = false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.selectedEspace = "";
        this.errors.label = "";
        this.errors.labelTec = "";
      }
    }
  };
</script>

<style>
  .scroll-area-oap-oag {
    position: absolute;
    height: 88%;
    width: 90%;
  }
</style>
